// extracted by mini-css-extract-plugin
export var aircallIframe = "_ea-3";
export var fabContainer = "_ea-5";
export var fabRinging = "_ea-6";
export var loadingOverlay = "_ea-4";
export var pulse = "_ea-7";
export var widgetContent = "_ea-2";
export var widgetPanel = "_ea-0";
export var widgetPanelExpanded = "_ea-1";